var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77778 0.777779C7.77778 0.348224 7.42955 0 7 0C6.57045 0 6.22222 0.348223 6.22222 0.777778V7C6.22222 7.42955 6.57045 7.77778 7 7.77778C7.42955 7.77778 7.77778 7.42955 7.77778 7V0.777779ZM12.0496 2.17202C11.7725 1.88425 11.3168 1.90541 11.0343 2.1879C10.7117 2.51053 10.7449 3.03973 11.0512 3.37796C11.9173 4.33464 12.4444 5.60469 12.4444 7C12.4444 10.01 10.01 12.4444 7 12.4444C3.99 12.4444 1.55556 10.01 1.55556 7C1.55556 5.60161 2.08502 4.32903 2.95027 3.36732C3.25304 3.03081 3.28414 2.50636 2.96405 2.18628C2.68248 1.9047 2.22831 1.88362 1.95201 2.17037C0.74293 3.42517 0 5.12198 0 7C0 10.8656 3.13444 14 7 14C10.8656 14 14 10.8656 14 7C14 5.12281 13.2577 3.42666 12.0496 2.17202Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.db508139ff6bb03d3e5ec43a4c63abf9.svg";
export { ForwardRef as ReactComponent };